export const skillCategories = [
  {
    category: 'Languages',
    items: [
      { name: 'Python', level: 4 },
      { name: 'Java', level: 3 },
      { name: 'C', level: 3 },
      { name: 'C++', level: 2 },
      { name: 'JavaScript', level: 4 },
    ],
  },
  {
    category: 'Frontend',
    items: [
      { name: 'HTML', level: 3 },
      { name: 'CSS', level: 4 },
    ],
  },
  {
    category: 'Framework',
    items: [
      { name: 'React', level: 4 },
      { name: 'Next.js', level: 2 },
      { name: 'SwiftUI', level: 2 },
      { name: 'FastAPI', level: 3 },
      { name: 'Node.js', level: 1 },
    ],
  },
  {
    category: 'AI',
    items: [
      { name: 'PyTorch', level: 3 },
      { name: 'OpenCV', level: 2 },
      { name: 'Agent Coding', level: 4 },
      { name: 'Vibe Coding', level: 4 },
    ],
  },
  {
    category: 'Database',
    items: [
      { name: 'MySQL', level: 1 },
      { name: 'Firebase DB', level: 3 },
    ],
  },
  {
    category: 'Infrastructure',
    items: [
      { name: 'Cloudflare', level: 3 },
      { name: 'Vercel', level: 2 },
      { name: 'Firebase', level: 3 },
      { name: 'Firebase Auth', level: 3 },
      { name: 'Docker', level: 1 },
    ],
  },
  {
    category: 'Embedded Systems',
    items: [
      { name: 'Arduino', level: 3 },
      { name: 'Raspberry Pi', level: 2 },
    ],
  },
  {
    category: 'Tools',
    items: [
      { name: 'Git', level: 3 },
      { name: 'GitHub', level: 3 },
      { name: 'Notion', level: 1 },
      { name: 'Android Studio', level: 4 },
    ],
  },
];
